import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from 'components/common/ErrorMessage';
import toast from 'react-hot-toast';
import { Spinner } from 'reactstrap';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { fetchStates } from 'slices/stateSlice';
import { stateSelector } from 'slices/stateSlice';
import { Select } from 'components/common/Select';
import PhoneInput from 'components/common/PhoneInput';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { setError } from 'slices/facilitiesSlice';
import { fetchFacilities } from 'slices/facilitiesSlice';
import { addFacility } from 'slices/facilitiesSlice';
import { updateFacility } from 'slices/facilitiesSlice';
import { facilitiesSelector } from 'slices/facilitiesSlice';

const apiService = new Api();
const AddFacilityForm = ({ item, handleClose, callback, show, statusPerm, userId }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
  const { error, loader } = useSelector(facilitiesSelector);
  const { state: states } = useSelector(stateSelector);
  const [allStates, setAllStates] = React.useState([]);
  const [disabled, setDisabled] = useState(false);
  const [filterStates, setfilterStates] = useState({
    label: "",
    value: ""
  })
const [buttonLoader, setButtonLoader] = useState(false)


  useEffect(() => {
    setValue('abbreviation', item?.abbreviation || '')
    setValue('phone', item?.phone || '')
    setValue('address', item?.address || '');
    setValue('zip_code', item?.zipcode || '');
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    dispatch(setError({}))
  }, [item])

  const ResetField = () => {
    setValue('abbreviation', '');
    setValue("phone", '');
    setValue('address', '');
    setValue('zip_code', '');
    setValue('status', 1)
    setValue("city_id", '')
    setValue("state_id", '')
  }

  useEffect(() => {
    !show && ResetField();
    return () => ResetField()
  }, [show])

  useEffect(() => {
    if (states?.length > 0) {
      if (item?.state_id)
        setValue("state_id", item?.state_id)
    }
    else setValue("state_id", "")

    if (item?.city_id) {
      setValue("city_id", item?.city_id)
    }
    else {
      setValue("city_id", "")
    }

  }, [item, states]);


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      handleClose()
      ResetField()
      setButtonLoader(false)
      dispatch(fetchFacilities(1, { user_id: userId }))
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
      setTimeout(() => {
        setButtonLoader(false)
      }, 1000);
    }
  };

  const onSubmit = (data) => {
    setButtonLoader(true)
    const formData = {
      ...data,
      user_id: userId,
    }

    if (item?.id) {
      dispatch(updateFacility(formData, item?.id, submitCallback, true));
    }
    else
      dispatch(addFacility(formData, submitCallback, true));

  }


  // #region States dropdown

  useEffect(() => {
    dispatch(fetchStates(1, { id: item?.state?.id }))
    if (item?.state?.name && item?.state?.id) {
      setfilterStates({
        label: item?.state?.name || "",
        value: item?.state?.id || ""
      })
    } else {
      setfilterStates(null)
    }
  }, [item?.state])


  const filteredStatesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchStates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    setAllStates(result?.data)
    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion


  // #region City dropdown
  const [allCities, setAllCities] = useState([])
  const [selectedCity, setSelectedCity] = useState({
    label: "",
    value: ""
  })
  const filteredCities = React.useMemo(() =>
    allCities?.map(val => {
      const object = {
        label: item?.city?.name || val.name,
        value: item?.city?.id || val.id,
      }
      return object
    }), [allCities, item?.city]);


  const filteredStates = React.useMemo(() => {

    setAllCities(item?.state?.name != null ? states?.find(state => state?.name == item?.state?.name)?.cities : [])
    return states?.map(item => {
      const object = {
        label: item?.name,
        value: item?.id,
      }
      return object
    })
  }, [states, item?.state?.name]);

  useEffect(() => {
    setSelectedCity(filteredCities)
  }, [filteredCities])

  useEffect(() => {
    if (item?.city?.name && item?.city?.id) {
      setSelectedCity({
        label: item?.city?.name || "",
        value: item?.city?.id || ""
      })
    } else {
      setSelectedCity(null)
    }
  }, [item?.city])

  //#endregion



  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row-primary">
        <h2>Abbreviation *</h2>
        <div className="w-100">
          <Controller
            name="abbreviation"
            control={control}
            rules={{
              required: 'Abbreviation is required'
            }}
            render={({ field }) => <input className="input-in type_inp" type="text" name='abbreviation' placeholder='Abbreviation' {...field} />}
          />
          {error?.errors?.abbreviation?.map((error) => (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={error} />
            </div>
          ))}
          {errors?.abbreviation?.message &&
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={errors?.abbreviation?.message} />
            </div>
          }
        </div>
      </div>
      <div className="row-primary">
        <h2>Cell Phone *</h2>
        <div className="w-100">
          <Controller
            name="phone"
            control={control}
            rules={{
              required: 'Phone field is required'
            }}
            render={({ field }) => <PhoneInput className={`input-in type_inp ${error?.errors?.phone ? "border-red" : ""} `}
              type="tel" name='phone' placeholder='Phone number' required {...field} />}
          />
          {error?.errors?.phone?.map((error) => (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={error} />
            </div>
          ))}
          {errors?.phone?.message &&
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={errors?.phone?.message} />
            </div>
          }
        </div>
      </div>

      <div className="row-primary">
        <h2>Address *</h2>
        <div className="w-100">
          <Controller
            name="address"
            rules={{
              required: 'Address required'
            }}
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='address' placeholder='Address' {...field} />}
          />
         {error?.errors?.address?.map((error) => (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={error} />
            </div>
          ))}
          {errors?.address?.message &&
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={errors?.address?.message} />
            </div>
          }
        </div>
      </div>

      <div className="row-primary">
        <h2>Select State</h2>
        <Controller
          name="state_id"
          control={control}
          render={({ field }) =>
            <div style={{ width: "100%" }}>
              <AsyncPaginate
                menuPlacement='auto'
                styles={{
                  ...selectCustomStyles,
                }}
                value={filterStates}
                defaultOptions={item?.state?.id ? filteredStates : []}
                loadOptions={filteredStatesLoadOptions}
                isClearable
                escapeClearsValue
                onChange={(obj) => {
                  setfilterStates(obj)
                  setAllCities(obj != null ? allStates?.find(states => states?.name == obj?.label)?.cities : [])
                  field.onChange(obj?.value);
                }}
                additional={{
                  page: item?.state?.id ? 2 : 1,
                }}
              />
              {error?.errors?.state_id?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}


            </div>
          }
        />
      </div>

      <div className="row-primary">
        <h2>City</h2>
        {/* <Controller
          name="city_id"
          control={control}
          render={({ field }) =>
            <div style={{ width: "100%" }}>
              <Select
                name="city_id"
                options={filteredCities || []}
                {...field}
                value={filterStates ?? item?.city ? (filteredCities?.find((opt) => field.value === opt.value) || []) : null}
              />
              {error?.errors?.city_id?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
            </div>
          }
        /> */}

        <Controller
            name="city_id"
            control={control}
            render={({ field }) =>
              <input className="input-in type_inp" type="text" name='city_id' placeholder="City"
                {...field}
                
              />
              
            }
        />
      </div>

      <div className="row-primary">
        <h2>Zip Code</h2>
        <div className="w-100">
          <Controller
            name="zip_code"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="number" name='zip_code' placeholder='zip code' {...field} />}
          />
          {error?.errors?.zip_code?.map((error) => (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={error} />
            </div>
          ))}
        </div>
      </div>

      {statusPerm &&
        <div className="row-primary" style={{ alignItems: "center" }}>
          <h2>Status</h2>
          <Controller name="status" control={control} required
            rules={{
              required: true
            }}
            render={({ field }) => (
              <CustomSwitch labelText={field.value == 1 ? "Active" : "Inactive"} checked={field.value} handleChange={(checked) => field.onChange(checked ? 1 : 0)} />
            )}
          />
        </div>
      }

      <div className="Form-footer">
        <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
        <button type="submit"  disabled={buttonLoader ? 'disabled' : ''}  className="main_button">
          {buttonLoader ?
            <>
              <Spinner size="sm">
                Loading...
              </Spinner>

              <span>
                {' '}Loading
              </span>
            </>
            :
            <span>
              {item?.id ? "Update" : "Create"}
            </span>
          }
        </button>
      </div>

    </form>
  )
}

const AddFacility = ({ item, onClose, callback, show, statusPerm, userId }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Facility</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddFacilityForm item={item} userId={userId} handleClose={onClose} show={show} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddFacility
